module.exports = __webpack_public_path__ + "img/theme11.11e24802.png";